import { IonButton } from '@ionic/react'
import React, { ComponentProps, forwardRef, PropsWithChildren } from 'react'

export interface ButtonProps extends ComponentProps<typeof IonButton> {}

const Button = forwardRef<HTMLIonButtonElement, PropsWithChildren<ButtonProps>>((props, ref) => {
	const isHollow = props.className?.includes('hollow')
	return (
		<IonButton
			{...props}
			ref={ref}
			className={`w-full hover rounded-full [--border-radius:10000px] ${
				isHollow
					? '[--box-shadow:none] ![--background:transparent] text-[#52ae32] dark:text-[#3cb49f]'
					: 'shadow-md dark:![--background:#3cb49f] ![--background:#52ae32] text-white'
			} ${props.className ?? ''}`}
		>
			{props.children}
		</IonButton>
	)
})

Button.displayName = 'Button'

export default Button
